<template>
    <div :class="classes([this.direction])">
        <div :class="classes('items')">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { useBEM } from '../../../common/utils/classnames';
let classnames = useBEM( 'hanzo-steps' );
export default {
    name: "h-steps",
    props: {
        active: Number,
        inactiveIcon: String,
        direction: {
            type: String,
            default: 'horizontal'
        },
        activeColor: {
            type: String,
            default: '#07c160'
        },
        activeIcon: {
            type: String,
            default: 'success'
        }
    },
    data() {
        return {
        steps: []
        };
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>